import {
  SingleChoiceQuestionFeedback,
  MultipleChoiceQuestionFeedback,
  ScorableQuestionFeedback,
  OpenQuestionFeedback,
  QuestoinnaireSubmitRequset
} from '../services/submit';
import { get } from 'lodash';

import { TypeName } from '../services/model';

export default (
  data: { [key: string]: any },
  itemTypeMap: { [key: string]: TypeName },
  questionnaire_token: string
) => {
  const single_choice_question_feedbacks: SingleChoiceQuestionFeedback[] = [];
  const multiple_choice_question_feedbacks: MultipleChoiceQuestionFeedback[] = [];
  const scorable_question_feedbacks: ScorableQuestionFeedback[] = [];
  const open_question_feedbacks: OpenQuestionFeedback[] = [];
  Object.keys(data).forEach((key) => {
    const value = data[key];
    const itemType = itemTypeMap[key];
    switch (itemType) {
      case 'description':
        value && open_question_feedbacks.push({ question_id: key, answer: value });
        break;
      case 'five_star_scoring':
        value &&
          scorable_question_feedbacks.push({
            question_id: key,
            answer: { score: get(value, '0'), specific_reason: get(value, '1', '') }
          });
        break;
      case 'multi_select':
        value &&
          value.length > 0 &&
          multiple_choice_question_feedbacks.push({
            question_id: key,
            answer: value.map((item: any) => {
              return {
                option_id: get(item, '0'),
                specific_reason: get(item, '1', '')
              };
            })
          });
        break;
      case 'select':
        value &&
          single_choice_question_feedbacks.push({
            question_id: key,
            answer: { option_id: get(value, '0'), specific_reason: get(value, '1', '') }
          });
        break;
      default:
        break;
    }
  });
  return {
    questionnaire_token,
    single_choice_question_feedbacks,
    multiple_choice_question_feedbacks,
    scorable_question_feedbacks,
    open_question_feedbacks
  } as QuestoinnaireSubmitRequset;
};
